export default {
    404: "Fehler 404!! Die Seite ist nicht verfügbar.",
    title_404: "Die Seite, die Sie erreichen möchten, ist leider nicht verfügbar",
    btn_404: "Zurück",
    manageScreenQuestion: "Question",
    manageScreenLocation: "Location description",
    manageSetGeolocation: "Standort festlegen",
    manageSetAsset: "Kennzeichnung",
    manageGeolocation: "Standort",
    manageUpdateBtn: "Aktualisieren",
    manageLatitude: "Breite",
    manageLongitude: "Längengrad",
    manageGPSAccuracy: "GPS-Genauigkeit {v1}m",
    manageGPSLocation: "GPS Standort",
    manageGPSAllowText: "Bitte erlauben Sie air-vote.com, die GPS-Standortdaten von Ihrem Handy abzurufen",
    manageGPSAllowSubtitle: "* wir verwenden die Daten nur wenn Sie diese Seite besuchen, um den Standort der Frage zu aktualisieren",
    manageGPSPopupLongDistance: "Ihre aktuellen GPS-Koordinaten sind weit von der vorherigen Aufkleberplatzierung {v1}m entfernt",
    manageGPSPopupBadAccuracyAndLongDistance: "Ihre aktuellen GPS-Koordinaten sind weit von der vorherigen Aufkleberplatzierung {v1}m entfernt und haben eine geringe Genauigkeit {v2}m",
    manageGPSPopupBadAccuracy: "Ihre aktuellen GPS-Koordinaten haben eine geringe Genauigkeit ({v1}m)",
    manageGPSPopupSureNewCoords: "Sind Sie sicher, dass Sie neue Koordinaten verwenden?",
    manageGPSPopupUseNewCoordsBtn: "Neue Koordinaten verwenden",
    manageGPSPopupChangeManuallyBtn: "Manuell ändern",
    manageMapBtn: "Diesen Standort verwenden",
    manageSaved: "Gespeichert",
    manageCopiedToClipboard: "In die Zwischenablage kopiert",
    manageGPSUnableToFetchMsg: "Der GPS-Standort konnte nicht abgerufen werden. Bitte versuchen Sie es erneut",
    manageGPSUnavailable: "GPS-Standort ist nicht verfügbar. Bitte versuchen Sie es erneut oder kontaktieren Sie unser Support-Team",
    manage_back_to_yard: "Back to yard",
    admin_RemoveItem: "Löschen {v1}",
    admin_AddItem: "Hinzufügen {v1}",
    admin_Admin: "Administrator/-in",
    admin_Owner: "Verwalter/-in",
    admin_Client: "Kunde/-in",
    admin_Votes: "Stimmen",
    admin_Profiles: "Benutzerprofile",
    admin_Organizations: "Organisationen",
    admin_showAllPlaces: "Alle Orte zeigen",
    admin_SaveRole: "Rolle speichern",
    admin_deleteRole: "Benutzerprofil löschen {v1} {v2} ?",
    admin_deleteVote: "Bewertung zu der Frage \"{v1}\" löschen",
    admin_deletePlace: "Ort \"{v1}\" löschen?",
    admin_deleteOrganization: "Organisation \"{v1}\" löschen?",
    admin_deletePlaceWarning: "** Alle zugehörigen Stimmen werden entfernt **",
    admin_successMessageAddOwner: "Besitzer hinzugefügt",
    admin_successMessageAddPlace: "Ort hinzugefügt",
    admin_successMessageRemoveOwner: "Besitzer gelöscht",
    admin_successMessageRemovePlace: "Ort gelöscht",
    admin_successMessageRemoveVote: "Bewertung gelöscht",
    admin_successMessageRemoveOrganization: "Organisation gelöscht",
    admin_successMessageSaveOrganization: "Organisation gespeichert",
    admin_successMessageChangeRole: "Rolle geändert",
    admin_Stickers: "die Aufkleber",
    admin_ChangeStatusToCancelled: "Status in \"Storniert\" ändern?",
    admin_ChangeStatusToSent: "Status in \"Gesendet\" ändern?",
    admin_ChangeStatusToCompleted: "Status in \"Fertig\" ändern?",
    admin_adminVotesShowAll: "Alle Bewertungen anzeigen",
    admin_searchByName: "Suche nach dem Namen",
    admin_signInAs: "Als: {v1} anmelden?",
    admin_ReturnToOriginalAccount: "Zurück zum ursprünglichen Benutzerkonto:  : {v1}?",
    admin_closeAccountRequests: "Kontoschließungsanfragen",
    admin_landingQuestions: "Landing Fragen",
    admin_firstName: "Name",
    admin_lastName: "Vorname",
    admin_contactEmail: "Ihre E-Mail-Adresse",
    admin_phone: "Telefonnummer",
    admin_success: "Erfolg",
    admin_userCreated: "Neuer Benutzer wurde erstellt",
    admin_sortBy: "Sortieren nach",
    admin_sortByName: "Namen",
    admin_sortByAdded: "Datum der Hinzufügung",
    admin_sortByUpdated: "Aktualisierung",
    admin_sortByEmail: "per E-Mail",
    admin_sortByCreated: "Erstellung",
    adminPanel: "Administrationsmenü",
    admin_Add: "Hinzufügen",
    admin_Places: "Orte",
    admin_UnQuestions: "Fragen",
    admin_ChooseYourPlace: "Wählen Sie Ihren Ort",
    admin_NothingFound: "Die Suche ergab keinen Treffer",
    admin_Delete: "Löschen",
    admin_delete_image: "Möchten Sie Bilder löschen?",
    admin_successImageDelete: "Das Bild wurde gelöscht",
    Track_vote: "Beobachten Sie Ihren Abstimmungen",
    Logout: "Abmeldung",
    Sync_status: "Synchronisierungsstatus",
    Success: "Erfolgreich",
    Error: "Fehler",
    Back: "Zurück",
    Thank_for_vote: "Vielen Dank für Ihre Stimme. Möchten Sie Ihre Stimmen beobachten? Sich einloggen mit",
    No_votes: "Sie haben noch keine Bewertungen abgegeben",
    statusMessage: "Bitte warten Sie...",
    Save: "Speichern",
    sign_in_to_connect: "Bitte loggen Sie sich bitte ein, um diesen QR-Code zu Ihrer Organisation anzuschließen",
    yes: "Ja",
    no: "Nein",
    YourVotes: "Ihre Stimmen",
    OtherVotes: "Bewertungen von anderen Benutzern",
    AirVotes: "Bewertungen insgesamt",
    Change: "Ändern",
    Submit: "Senden",
    Cancel: "Rückgängig machen",
    CancelRequest: "Die Anfrage wurde rückgängig gemacht",
    ChangedYourMind: "Ihre Meinung geändert? Wählen Sie eine neue Abstimmung! Beachten Sie, dass Datum und Uhrzeit gleich bleiben.",
    NotConnectedPlaceToAirVote: "Dieser Ort ist derzeit nicht mit AirVote verbunden",
    From: "Von",
    To: "Bis",
    writeFeedBack: "Notiz hinzufügen (optional)",
    voteSuccessText_1: "Vielen Dank! Ihre Bewertung wurde gesendet.",
    voteSuccessText_2: "Möchten Sie Ihre Bewertung ändern? Klicken Sie auf ein anderes Emoticon.",
    voteSuccessText_3: "Haben Sie etwas zu sagen? Hier können Sie optionale Notiz hinterlassen",
    feedbackTitle: "Notiz hinzufügen",
    feedbackTitleSoSo: "Was wäre besser?",
    feedbackTitleSad: "Was ist falsch?",
    writeAReview: "Öffentliche Abstimmung",
    writeAReviewTitle: "Hier können Sie eine Bewertung für {v1} abgeben:",
    bflow_BusinesConnectQuestion: "Wählen Sie bitte Ihr Geschäft, um die Frage zu verbinden \"{v1}\"",
    bflow_BusinesConnectQuestionSuccess: "Frage wurde erfolgreich verknüpft ",
    bflow_ChoosePlace: "Bitte wählen Sie einen Ort, um die Frage zu verbinden \"{v1}\"",
    bflow_AddQuestionSuccess: "Frage hinzugefügt",
    bflow_BecameOwnerPlace: "Erledigt. Sie sind jetzt ein ausgewiesener Ansprechpartner für \"{v1}\"",
    bflow_BecameOwnerPlaceConfirm: "Markieren wir Sie als Ansprechperson für \"{v1}\"?",
    bflow_ConfirmConnectQuestionToPlace: "Frage \"{v1}\" zu dem Ort \"{v2}\" hinzufügen?",
    bflow_ConfirmConnectQuestionToPlacebelow: "Frage \"{v1}\" zu dem Ort unten hinzufügen?",
    bflow_ConnectedQuestion: "Fragenbindung...",
    bflow_finishBusinesFlow: "Möchten Sie sich abmelden?",
    bi_Name: "Name",
    bi_OfficialName: "Name der Organisation",
    bi_ContactEmail: "E-Mail-Adresse",
    bi_Phone: "Telefonnummer",
    bi_Password: "Passwort",
    bi_Edit: "Bearbeiten",
    bi_Address: "Adresse",
    bi_WebsiteUrl: "Web-Seite",
    bi_validation_OrganizationRequired: "Name der Organisation ist ein Pflichtfeld",
    bi_validation_Email: "E-Mail-Adresse ist ungültig",
    bi_validation_Phone: "Telefonnummer ist ungültig",
    bi_validation_Website: "Web-Seite ist ungültig",
    bi_first_Name: "Vorname",
    bi_last_Name: "Nachname",
    own_anyConnectedPlace: "Sie haben noch keinen verbundenen Ort",
    bi_confirm_email: "E-Mail-Adresse nicht bestätigt",
    bi_resend_email: "Autorisierungs-E-Mail erneut senden",
    bi_resend_email_success: "Bestätigungs-E-Mail wurde erfolgreich erneut gesendet",
    bi_change_password: "Passwort ändern",
    bi_set_password: "Passwort festlegen",
    bi_cancel_password: "Passwortänderung abbrechen",
    bi_current_password: "Aktuelles Passwort",
    bi_new_password: "Neues Passwort",
    bi_retype_password: "Fügen Sie neues Passwort erneut ein",
    bi_save_password: "Save new password",
    bi_password_change_success: "Bitte bestätigen Sie Ihre E-Mail-Adresse",
    bi_confirm_new_password: "Confirm Password",
    own_use_w3w: "Standort -> what3words verwenden",
    own_email_Confim: "Please confirm your email address",
    own_myQuestions: "Meine Fragen",
    own_createQuestion: "Frage erstellen",
    own_orderStickers: "QR-Aufkleber bestellen",
    own_selectRange: "Bereich auswählen",
    own_today: "heute",
    own_last7days: "die letzten 7 Tage",
    own_lastMonth: "letzter Monat",
    own_allTime: "der ganze Zeitraum",
    own_custom: "In beliebiger Weise",
    own_Search: "Suche",
    own_showMore: "Mehr anzeigen",
    own_showLess: "Weniger anzeigen",
    own_Locations: "Standorte",
    own_Questions: "Fragen",
    own_Total: "Insgesamt",
    own_Happy: "Sehr gut",
    own_SoSo: "Genügend",
    own_Sad: "Schlecht",
    own_green: "Grün",
    own_yellow: "Gelb",
    own_red: "Rot",
    own_EditQuestion: "Frage bearbeiten",
    own_DownloadPDF: "Aufkleber generieren",
    own_DownloadPDFMobile: "Aufkleber generieren",
    own_OrderSticker: "QR-Aufkleber bestellen",
    own_DeleteQuestion: "Frage löschen",
    own_DownloadAndPrint: "Herunterladen und drucken",
    own_OrderStickerFrom: "QR-Aufkleber bei AirVote® bestellen",
    own_DeliveryAddress: "Lieferadresse eingeben",
    own_RecipientName: "Name des Empfängers",
    own_RecipientPhone: "Tel. des Empfängers",
    own_RecipientEmail: "E-Mail-Adresse des Empfängers",
    own_Comment: "Kommentar",
    own_ShowZeroVotes: "Fragen ohne Feedback",
    own_CreateNew: "Neue AirVote®-Frage erstellen",
    own_EnterQuestion: "Geben Sie hier Ihre AirVote®-Frage ein",
    own_SpecifyLocation: "Standort angeben",
    own_DownloadPDF_Title: "Frage hinzugefügt!",
    own_DownloadPDF_Description: "Sie können jetzt ein PDF mit dem Fragen-Aufkleber herunterladen. Um einen bei AirVote® zu bestellen, verwenden Sie \"Aufkleber generieren\" in dem Frage-Menü",
    own_DownloadPDF_EditTitle: "Frage aktualisiert",
    own_SureTODelete: "Soll Ihre Frage gelöscht werden?",
    own_DownloadSticker: "PDF-Aufkleber herunterladen",
    own_StickerProportion: "Wählen Sie die Aufklebergröße",
    own_PanelTextLeaflet: "Flugblatt",
    own_PanelTextBusiness: "Visitenkarte",
    own_PanelTextExtended: "Erweiterter Flugblatt",
    own_PanelSubtitleLeaflet: "Standard AirVote-Aufkleber mit Fragen und Smileys. Drucken Sie es aus und bringen Sie es in Reichweite der Kunden an",
    own_PanelSubtitleExtended: "Standardaufkleber mit zusätzlichen Tipps zur Bedeutung von Smileys",
    own_PanelSubtitleBusiness: "Kompakteres Design zum Drucken und Verteilen als Visitenkarten",
    own_AllVotesWillDeleted: "Alle Stimmen für diese AirVote®-Frage werden gelöscht",
    own_HasBeenDeleted: "Ihre Frage wurde gelöscht",
    own_DontForgetCreate: "Vergessen Sie nicht, eine neue zu erstellen!",
    own_Manage: "Steuerung",
    own_Title: "Willkommen beim AirVote-Geschäfts-Dashboard!",
    own_Business: "Ihr Geschäft",
    own_Subitle: "Geben Sie den Namen Ihres Unternehmens an, um Fragen erstellen zu können. Das kann jederzeit\nspäter geändert werden",
    own_Address: "Adresse",
    own_AssetId: "Kennung",
    own_BusinessName: "Ihr Unternehmensname",
    own_SaveBtn: "Speichern und fortfahren",
    own_SaveBtnWithQuestion: "Speichern und meine QR-Smileys bekommen",
    own_CanNotFind: "Ich kann mein Geschäft nicht finden",
    own_PleaseStartWriting: "Starten Sie den Namen Ihres Unternehmens zu schreiben und wählen Sie sie aus der Dropdownliste",
    AnalyticSettings: "Analyseoptionen",
    AnalyticDescription: "Mit diesen Einstellungen konfigurieren Sie, wie Daten im Analytics-Dashboard angezeigt werden",
    AnalyticIndex: "Bevorzugter Analyseindex",
    AnalyticWhatMean: "Was bedeutet das?",
    AnalyticWhatMeanIndex: "Warum ist Index eine gute Idee?",
    AnalyticWhatMeanIndexDescription: "Index bietet eine objektive Messgröße, um die Trends im Zeitverlauf zu verfolgen und die Leistung in verschiedenen Bereichen zu vergleichen",
    AnalyticWhatMeanIndexValue: "Wie berechnet AirVote Indexwerte:",
    AnalyticIndexPromouterScore: "・ Net Promoter Score:  # \"glückliche\" Bewertungen * 100% + # \"so-so\" Bewertungen* 0% - # \"traurige\" Bewertungen* 100%. Die höchste Punktzahl ist 100. Die niedrigste Punktzahl ist -100.",
    AnalyticIndexAirVoteScore: "・ AirVote Score: # \"glückliche* Bewertungen * 100% + #\"so-so\" Bewertungen* 50%. Die höchste Punktzahl ist 100. Die niedrigste Punktzahl ist 0.",
    ThereIsAnError: "Bitte geben Sie einen gültigen Wert ein",
    StickerStatus: "Aufkleber-Status",
    Requested: "Angefragt",
    Sent: "Gesendet",
    Cancelled: "Storniert",
    Close: "Schließen",
    welcomeModalTitle: "Finden Sie Ihr Unternehmen auf der Karte",
    welcomeModalSubtitle: "Wir verwenden Google-Daten, um Sie bei der Registrierung Ihres Geschäftes in AirVote zu unterstützen.",
    welcomeModalSearchYouBusinass: "Suchen Sie nach Ihrem Geschäft mithilfe des Eingabefeldes (oben auf dem Bildschirm)",
    welcomeModalPickOnMap: "Oder wählen Sie es auf der Karte",
    welcomeModalNotOnGoogle: "Wenn Ihr Geschäft nicht bei Google ist, dann kontaktieren Sie uns bitte per E-Mail",
    mapTipsSearch: "Finden Sie Ihr Geschäft anhand seines Namens",
    mapTipsPick: "Oder wählen Sie es auf der Karte",
    OK: "Okay",
    Location: "Standort",
    Question: "Frage",
    thankVoteTitle1: "Ihr Feedback wurde erfolgreich gespeichert",
    thankVoteTitle2_1: "Vielen Dank für Ihre Stimme",
    thankVoteTitle2_2: "Melden Sie sich bei AirVote® an, damit Sie Ihre Stimmen überprüfen und ändern können",
    companyManagement: "Firmenmanagement",
    sites: "Niederlassungen ",
    site: "Niederlassung",
    SitesDescription: "Niederlassungen sind verschiedene Filialeoder Standorte Ihres Unternehmens. Jedem Standort kann ein oder mehrere Standortmanager zugewiesen werden, die das AirVote®-System des Standorts gemeinsam verwalten.",
    addNewSite: "Niederlassung hinzufügen",
    siteDetail: "Niederlassungsinfo",
    questionsAndAnalytics: "Fragen und Analytik",
    companyInformation: "Firmeninformation",
    companyManagers: "Geschäftsführung",
    saveChanges: "Änderungen speichern",
    companyManagersDescription: "Sie können andere die Firmenmanager damit beauftragen, um das AirVote-System Ihres Geschäftes gemeinsam zu verwalten.",
    Invite: "Einladung",
    EnterEmailToAssignCompanyManager: "E-Mail-Adresse des Managers/der Managerin",
    enterSeveralEmailByComma: "Sie können mehrere E-Mail-Adressen durch Komma getrennt eingeben",
    Pending: "Erwartung",
    Accepted: "Akzeptiert",
    Remove: "Löschen",
    ActiveManagers: "Aktive Manager",
    NoOthersCompanyManagersAssigned: "Keine anderen Unternehmensleiter zugewiesen",
    removeManager: "Manager löschen: {v1}?",
    all: "Alle",
    editManagers: "Managerliste bearbeiten",
    assignManagers: "Als Manager einsetzen",
    viewAnalytic: "Analytics anzeigen",
    deleteSite: "Niederlassung entfernen",
    deleteSiteConfirm: "Niederlassung: {v1} entfernen?",
    siteManagers: "Niederlassung Manager",
    SiteManagersNotAssigned: "Nicht zugeordnet",
    siteName: "Name der Niederlassung",
    siteAddress: "Website",
    siteAddressSidebar: "Adresse der Niederlassung",
    Website: "Website",
    Email: "E-Mail",
    Alias: "Alias",
    EditPhoto: "Foto bearbeiten",
    SitePhoto: "Foto der Niederlassung ",
    AirVoteSuggestsTitle: "AirVote schlägt vor",
    SearchForQuestion: "Vorgeschlagene Fragen",
    UseQuestion: "Diese Frage verwenden",
    ImagesSupportedParams: "Bilder werden in den PNG- und JPG-Formaten akzeptiert. Die maximale Größe des Fotos beträgt 5 MB",
    UploadFile: "Datei hochladen",
    RemovePhoto: "Foto entfernen",
    ReturnBtn: "Zurück",
    RemovePhotoConfirm: "Möchten Sie das Foto der Niederlassung wirklich entfernen?",
    RemovePhotoSuccess: "Foto wurde erfolgreich gelöscht",
    WrongFormat: "Falsches Format. Bitte verwenden Sie PNG oder JPG",
    PhotoOverweight: "Foto größer als {v1}MB",
    cancelInvite: "Anfrage: {v1} abbrechen?",
    createSiteMap: "Eine neue Niederlassung mit dem Standort: {v1} erstellen?",
    chooseNewPlaceFrOrganization: "Bitte wählen Sie einen neuen Standort für Ihre Organisation",
    MyBusinessIsMultipleSites: "Mein Unternehmen hat mehrere Niederlassungen",
    goingToMultipleSitesMode: "Hiermit beantragen Sie den Modus der mehreren Niederlassungen für Ihre Organisation",
    by_questions: "Fragen",
    by_sites: "Niederlassungen",
    by_locations: "Standorte",
    groupBy: "Gruppieren nach",
    Diagram: "Diagramm",
    ID: "ID",
    Filter: "Filter",
    Comments: "Kommentare",
    ownLastVotes: "letzte Bewertungen",
    IndexAirvote: "AirVote-Index",
    TotalVotes: "Gesamt",
    Notifications: "Meldungen",
    CloseAccount: "Mein Konto schließen",
    DowngradeToClient: "Mich zum Kunden herunterstufen",
    SendNotificationEach2: "bewertungen",
    SMS: "SMS",
    Reports: "Berichte",
    daily: "Täglich",
    weekly: "Wöchentlich",
    monthly: "Monatlich",
    SendRequestToClose: "Eine Anfrage senden, um das Konto zu schließen?",
    SendRequestToRestore: "Kontowiederherstellungsanfrage senden?",
    RestoreAccount: "Konto wiederherstellen",
    DowngradeProfileToClient: "Profil auf Kundenrolle herabstufen?",
    ProfileSettings: "Profileinstellungen",
    savedSuccessfuly: "Erfolgreich gespeichert",
    Message: "Meldung",
    sendAlertEvery: "Senden sie mir eine Meldung je",
    checkboxSoSo: "Genügend",
    checkboxHappy: "Sehr gut",
    checkboxSad: "Schlecht",
    NoData: "Keine Daten",
    Decline: "Ablehnen",
    Approve: "Genehmigen",
    DeclineRequest: "Kontoschließungsanfrage ablehnen?",
    ApproveRequest: "Kontoschließungsanfrage genehmigen?",
    MyPlaces: "Meine Orte",
    EmptySiteTitle: "In Ihrem Unternehmen sind keine Niederlassungen konfiguriert. Fügen Sie eine hinzu!",
    EmptySiteDescription: "Niederlassungen sind verschiedene Filiale oder Standorte Ihres Unternehmens. Jedem Standort kann ein oder mehrere Standortmanager zugewiesen werden, die das AirVote®-System des Standorts gemeinsam verwalten und den Zugriff auf Analytik der Niederlassungen haben können.",
    accountSettings: "Kontoeinstellungen",
    accountSettingsDescription: "Meine Profildaten ändern, Meldungen und erhaltene Berichte verwalten",
    otherOptions: "Andere Optionen",
    UploadNewPhoto: "Neues Foto hochladen",
    receiveBadVotesViaSms: "Sie können Meldungen über Bewertungen per E-Mail oder SMS erhalten",
    Threshold: "Grenze",
    SoSoVotes: "So-so Stimmen",
    Channel: "Kommunikationsweg",
    DisableAllNotifications: "Alle Benachrichtigungen deaktivieren",
    EnableAllNotifications: "Alle Benachrichtigungen aktivieren",
    sendDetailedReportToEmail: "Wir können detaillierte Berichte an Ihre E-Mail-Adresse senden",
    Regularity: "Regelmäßigkeit",
    nothingSelected: "Nichts ausgewählt",
    allNotificationsDisabled: "Alle Benachrichtigungen sind deaktiviert",
    createNewUser: "Neuen Benutzer erstellen",
    exportRawData: "Exportieren",
    exportTo: "Exportieren nach",
    w3wTitle: "Einfache Möglichkeit, den Standort überall auf der Welt zu beschreiben",
    w3wLearnMore: "Mehr erfahren",
    unassignedQuestion: "Nicht zugewiesene Fragen filtern",
    moreOptiosPopuoTitle: "Mehr Optionen",
    driverMainText: "Ihr Konto {v1} hat nur Zugriff auf die Verwaltung von Platzierungen und Standorten.\n" +
        "Verwenden Sie Ihr Management-Login, um vollen Zugriff auf das {v2} Dashboard zu erhalten.",
    own_filter_placeholder: "Tippen Sie, um zu filtern",
    tab_Map: "Karte",
    smileysMailTitle: "Ihre AirVote QR Smileys sind unterwegs!",
    smileysMailSubtitle: "Überprüfen Sie {v1} - Ihre QR-Smileys sind bereits vorhanden. Wenn Sie sie nicht innerhalb weniger Minuten erhalten, bitte dann Ihren Spam-Ordner überprüfen oder",
    smileysMailDownload: "hier herunterladen",
    smileysMailChecklist: "Sie können sich jetzt bei Ihrem Geschäfts-Dashboard anmelden. Dort kann man:",
    smileysMailChecklistFirst: "Kundenfeedbackberichte in Echtzeit nachschauen",
    smileysMailChecklistSecond: "Zusätzliche Fragen erstellen und drucken",
    smileysMailChecklistThird: "Echtzeit-Informierung für Problembereiche konfigurieren",
    smileysMailChecklistFourth: "Erweiterte Analysen anzeigen",
    smileysMailChecklistMore: "... und vieles mehr!",
    smileysMailChecklistBtn: "Zu meinem Geschäfts-Dashboard",
    smileysMailChecklistBack: "Zurück zur Website",
    signIn_enter: "Sich anmelden mit",
    signIn_or: "oder",
    signIn_difficulties: "Haben Sie Schwierigkeiten?",
    signIn_contact: "Kontaktieren Sie uns unter",
    question_suggestions_freq_title: "Kürzlich verwendete",
    signIn_signIn_title: "Anmeldung",
    signIn_signUp_title: "Registrierung",
    signIn_enter_using_email: "oder mit Ihrer E-Mail einloggen",
    signIn_email_hint: "E-Mail-Adresse",
    signIn_password_hint: "Kennwort",
    signIn_signInBtn: "Anmelden",
    signIn_forgotPass_btn: "Passwort vergessen?",
    signIn_noCreditReq: "Keine Kreditkarte benötigt",
    signIn_firstName_hint: "Vorname",
    signIn_lastName_hint: "Nachname",
    signIn_signUp_btn: "Konto erstellen",
    signIn_useMedia: "Oder registrieren Sie sich über soziale Netzwerke",
    signIn_agreeTo: "Ich stimme AirVote zu",
    signIn_tAndC: "Bedingungen und Konditionen",
    signIn_recoverPassword: "den Passwort wieder herstellen",
    signIn_recoverPassSubtitle: "Geben Sie die E-Mail-Adresse ein, die bei der Registrierung verwendet wurde",
    signIn_recoverPassContinue: "Weiter",
    signIn_recoverPassBack: "Zurück zur Anmeldung",
    signIn_codeAlreadyUsed: "This reset password code is already used",
    signIn_protected: "Diese Website ist durch reCAPTCHA geschützt und es gelten",
    signIn_privacyPolice: "die Datenschutzbestimmungen",
    signIn_and: "und",
    signIn_Terms: "Nutzungsbedingungen von Google",
    signIn_Login: "Einloggen mit {v1}",
    signIn_Register: "Anmeldung mit {v1}",
    signIn_RegisterWithEmail: "Registrieren Sie sich mit E-Mail-Adresse",
    signIn_RegisterWithQuestion: "Weiter: Über mein Geschäft",
    signIn_SeparatorText: "ODER",
    signIn_TitleWithQuestion: "Registrieren Sie sich bei AirVote, um:",
    signIn_ChecklistFirst: "QR-Smileys per E-Mail zu erhalten",
    signIn_ChecklistSecond: "Auf Ihr Geschäfts-Dashboard zuzugreifen und Bewertungen nachzuschauen",
    signIn_LookAtEmail: "Please check your email for further instructions",
    resetPasswordRequestCancel: "Your password reset request was cancelled",
    resetPasswordRequestAlreadyCanceled: "Your password reset is already cancelled",
    changePasswordFormTitle: "Change Password",
    passwordDontMatch: "Passwords don't match",
    auth_confirm_email_confirming: "Bestätigung Ihrer E-Mail-Adresse 🔄",
    auth_confirm_email_confirmed: "E-Mail-Adresse erfolgreich bestätigt ✅\nWeiterleitung an das Geschäfts-Dashboard...",
    auth_confirm_email_already_confirm: "Ihre E-Mail Adresse wurde bereits bestätigt",
    login_btn_link: "Anmeldung",
    login_btn_text: "zu Ihrem Geschäfts-Dashboard",
    giveawayBottom_title: 'Tippen Sie hier, um an unserer Geschenkkartenverlosung teilzunehmen!',
    giveawayBottomFinish_title: 'Sie wurden zur Geschenkkartenverlosung hinzugefügt!',
    giveawayPopup_title: 'AN EINER GESCHENKKARTEVERLOSUNG TEILNEHMEN',
    giveawayPopup_login: 'Mit Google oder Facebook anmelden',
    giveawayPopup_review: 'Hinterlassen Sie eine Bewertung auf einer der Seiten von {v1}',
    giveawayPopup_entered: 'Sie werden an der Verlosung teilnehmen',
    giveawayPopup_BtnLogin: 'Mit Anmeldung beginnen',
    giveawayPopup_BtnReview: 'Bewertung hinterlassen',
    giveawayPopup_cancel: 'Ich möchte daran nicht teilnehmen',
    giveawayPopup_finalStep: 'Wir bedanken uns für Ihre ehrliche Bewertung!\n\nSie wurden zu unserer Geschenkkartenverlosung hinzugefügt.\n\nKommen Sie zurück und stimmen Sie erneut ab: Jede Bewertung erhöht Ihre Chancen!',
    giveawayPopup_proceedReview: "Fortfahren, um die Bewertung abzugeben",
    password_validation_min_length: "Mindestens 6 Zeichen lang",
    password_validation_uppercase: "Ein Großbuchstabe",
    password_validation_lowercase: "Ein Kleinbuchstabe",
    loadPdfProgress: "Bitte warten Sie, bis Ihr PDF generiert wird 🔄",
    showManagePopupTitle: "Fragen verwalten, QR-Smileys herunterladen",
    showManagePopupSubtitle: "Willkommen im AirVote-Geschäfts-Dashboard! Jeder Block, den Sie auf dem Bildschirm sehen, ist eine Frage, die Sie gestellt haben. Verwenden Sie das Symbol, um Fragen zu verwalten: Bearbeiten, Entfernen oder Herunterladen QR-Smileys als PDF",
    showFeedbackPopupTitle: "Fangen Sie an, Feedback zu erhalten",
    showFeedbackPopupSubtitle: "Wenn Sie Ihre QR-Smileys gedruckt haben, platzieren Sie sie an einer Stelle, die für den Kunden sichtbar ist. Jede Bewertung wird sofort in Ihrem Geschäfts-Dashboard angezeigt",
    showAlertsPopupTitle: "Einrichten und Empfangen von Benachrichtigungen",
    showAlertsPopupSubtitle: "Herzlichen Glückwunsch zu Ihrem ersten Feedback! Wussten Sie, dass Sie per SMS und E-Mail über jede Bewertung informiert werden können? Gehen Sie zu Ihrer Profilseite, um Benachrichtigungen einzurichten",
    helpCenterTitle: "Hilfezentrum",
    dataReportPopup: 'Keine Daten verfügbar. Bitte ändern Sie Ihre Filter oder wählen Sie einen anderen Zeitraum',
    dataReportPopupMobileXLSX: 'Diese Datei enthält nur die Abstimmungsdaten. Für detaillierte Abstimmungsanalysen und Diagramme verwenden Sie bitte das AirVote-Dashboard auf dem PC oder Mac',
    unsubscribeBtn: "Unsubscribe",
    unsubscribeSaveBtn: "Update settings",
    unsubscribePopupText: "Unsubscribed successfully",
    orderBannerSubtitle: "Wir können Ihre Fragen auf wasserdichtem Vinyl ausdrucken und in alle Winkel der Welt versenden",
    orderBannerBtn: "Aufkleber bestellen",
    orderStickersBtn: "QR-Aufkleber bestellen",
    orderPageBtn: "Los geht's",
    orderSelectTitle: " Wählen Sie Fragen aus, die Sie drucken möchten",
    orderBusinessSite: 'Niederlassung',
    orderBusinessPlacement: 'Standort',
    orderTotal: 'Bestellpreis',
    orderDelivery: 'Lieferung',
    orderDeliveryText: 'Gratis',
    orderFormTitle: 'Schließen Sie Ihre Bestellung ab',
    orderFormSubtitle: 'Voraussichtliche Lieferzeit beträgt 10-15 Tage',
    orderShippingTitle: 'Versand außerhalb der USA oder Europa',
    orderShippingSubtitle: 'Wenden Sie sich an AirVote, um das Bestellangebot einschließlich aller Versand- und Zollgebühren zu erhalten',
    orderQuote: 'Preise anfordern',
    orderSuccessPayment: 'Ihre Bestellung wurde erfolgreich erstellt. Wir werden uns in Kürze mit Ihnen in Verbindung setzen und Ihnen den Preis der Bestellung mitteilen',
    orderSuccessPayPal: 'Ihre Bestellung wurde erfolgreich erstellt und bezahlt',
    orderBtnToDashboard: 'Weiter zum Dashboard',
    orderShippingBlockTitle: 'Lieferinformation',
    orderCountryLabel: 'Land',
    orderStickerSizeLabel: 'Aufklebergröße',
    own_votesNotFound: 'Anscheinend haben Sie keine aktuellen Stimmen 😔\n\nBitte überprüfen Sie, ob Ihre AirVote-Fragen lokal eingestellt sind und ob Sticker noch an ihrem Platz sind und richtig funktionieren ',
    own_votesQuestion: 'Frage:',
    own_votesPlacement: 'Standort:',
    own_votesPriorVotes: 'Vorherige Bewertungen des Benutzers:',
    own_votesUser: 'Benutzer:',
    own_votesComment: 'Kommentar:',
    own_votesContactInfo: 'Kontaktinformation:',
    bulkPlacement: 'Bulk Standortänderung',
    bulkPlacementPopupSavedQuestions: 'Gewählte Fragen',
    bulkPlacementPopupSelectAll: 'Alle wählen',
    bulkSuccessfulPlaceEdit: "Standort wurde erfolgreich geändert",
    bulkInputPlaceHolder: "Neuer Standort",
    manageNotEnoughPermissions: "Sie haben nicht genügend Berechtigungen, um diese AirVote-Frage zu verwalten. Bitte melden Sie sich mit einem anderen Konto an oder fragen Sie nach einer Berechtigung",
    showAllVotes: "Alle letzten Stimmen anzeigen",
    setupTelegramBtn: "Telegram Bot einrichten",
    copy: "Kopieren",
    telegramPopupGroup: "Bot zur Gruppe hinzufügen",
    telegramPopupPrivate: "Bot zum privaten Chat hinzufügen",
    telegramPopupTitle: "Ihre Hash",
    telegramHashAvailable: "Aktuelle Hash ist für 1 Stunde verfügbar",
    emailSignature: 'Elektronische Kommunikation',
    emailSignatureSubtitle: "Kopieren Sie die Smileys und fügen Sie sie in Ihre E-Mails, elektronischen Rechnungen oder für Online-Präsentationen ein",
    emailSignatureTitle: 'Wie funktioniert AirVote bisher für Sie?',
    emailSignatureClick: 'Klicken Sie auf einen Smiley, um ein Feedback zu hinterlassen',
    emailSignatureCopyLink: 'Link kopieren',
    singleEmailSignaturePageTitle: 'Fügen Sie AirVote E-Smiley zu Ihrer Kommunikation hinzu',
    copied: 'Kopiert',
    airLeads: 'AirLeads',
    serviceLogs: 'Service logs',
    serviceLog: 'Dienstprotokoll',
    airLeadSubmittedBy: 'Eingereicht von:',
    airLeadChooseDriver: 'fahrer wählen',
    airLeadCompanyName: 'Name der Firma',
    airLeadSiteType: 'Site-Typ',
    airLeadOpportunity: 'Gelegenheit',
    airLeadCustomer: 'Kundin',
    airLeadAdditionalNotes: 'Zusätzliche Bemerkungen',
    airLeadMoreService: 'Mehr Service',
    airLeadMoreUnits: 'Mehr Einheiten',
    airLeadSink: 'Ein Waschbecken',
    airLeadCallThem: 'Um sie anzurufen',
    airLeadSubmitALead: 'Einen Lead einreichen',
    airLeadHideLeads: 'Geschlossene Leads ausblenden',
    airLeadShowAllLeads: 'Alle Leads anzeigen',
    airLeadDashboardDate: 'Datum',
    airLeadDashboardType: 'Typ',
    airLeadDashboardStatus: 'Status',
    airLeadDashboardStatusNotes: 'Statushinweise',
    airLeadDashboardLastActionDate: 'Datum der letzten Aktion',
    airLeadDashboardActionBy: 'Aktion von',
    airLeadDashboardSalesFollowUp: 'Verkaufsnachverfolgung',
    airLeadDashboardNotClosed: 'Nicht geschlossen',
    airLeadDashboardClosedWon: 'Geschlossen/Gewonnen',
    airLeadDashboardNotQualified: 'Nicht qualifiziert',
    airLeadDashboardCommission: 'Kommission',
    airLeadDashboardNotLeadsFound: 'Keine Leads gefunden',
    airLeadDashboardRefresh: 'Aktualisierung',
    airLeadInfoPopupDriver: 'Treiber',
    airLeadInfoPopupNotes: 'Anmerkungen',
    airLeadInfoPopupLocation: 'Ort',
    airLeadInfoPopupViewOnMap: 'Auf Karte anzeigen',
    airLeadInfoPopupServices: 'Dienstleistungen',
    airLeadStatusAndCommissionError: 'Bitte geben Sie Statusnotizen und Provision ein, um einen Lead zu schließen',
    airLeadStatusNotesError: 'Bitte geben Sie Statusnotizen ein, um einen Lead zu schließen',
    airLeadNewCustomerLead: 'Neuer Kundenkontakt',
    airLeadExistingCustomer: 'Bestehende Kundenleitung',
    airLeadPleaseChooseDriver: 'Bitte wählen Sie einen Fahrer',
    airLeadPleaseCompanyInfo: 'Bitte Firmendaten eingeben',
    airLeadPleaseCustomerInfo: 'Bitte Kundendaten eingeben',
    airLeadGoodLack: 'Viel Glück bei deiner Führung! \nVielen Dank für Ihre Hilfe bei der Gewinnung neuer Kunden!',
    airLeadCommission: 'Provision sollte größer als 0 . sein',
    airLeadNumberShouldContains: 'Nummer sollte weniger als 3 Ziffern enthalten',
    sldPlaceGuid: 'Leitfaden platzieren',
    sldOrganizationGuid: 'Organisationsleitfaden',
    sldGetPlaceConfig: 'Konfiguration neu laden',
    sldEnableDetails: 'Details der 2. Ebene aktivieren',
    sldBasicConfig: 'Grundkonfiguration',
    sldScreenTitle: 'Bildschirmtitel',
    sldScreenSubTitle: 'Bildschirmtitel',
    sldScreenBackground: 'Bildschirmhintergrund:',
    sldMaxCount: 'Maximale Anzahl ausgewählter Elemente',
    sldEnterForUnlimited: 'Geben Sie 0 für unbegrenzt ein',
    sldShowComment: 'Kommentar immer anzeigen',
    sldBlocks: 'Blöcke:',
    sldText: 'Text',
    sldGreenScreen: 'Grüner Bildschirm',
    sldYellowScreen: 'Gelber Bildschirm',
    sldRedScreen: 'Roter Bildschirm',
    sldOverrideSettings: 'Grundeinstellungen überschreiben',
    sldOverrideBlocks: 'Basisblöcke überschreiben',
    sldSecondLevelDetails: 'Details der zweiten Ebene',
    configMissingMsg: 'Die Konfiguration fehlt, möchten Sie sie aktivieren',
    sldTakeFromPlace: 'Vom Ort nehmen',
    sldChooseAnIcon: 'Wählen Sie ein Symbol',
    sldEditIcon: 'Symbol bearbeiten',
    sldUploadIcon: 'Neues Icon hochladen',
    sldIconTag: 'Icon-Tag',
    sldPleaseFillInput: 'Bitte füllen Sie das Feld',
    sldDefaultText: 'Standardtext',
    sldChooseIcon: 'Bitte wählen Sie ein Symbol',
    sldSaveAndAddMore: 'Speichern und mehr hinzufügen',
    sldAddIcon: 'Symbol hinzufügen',
    sldAreYouSure: "Sollen Sie dieses Bild löschen?",
    enableServiceLog: 'Aktivieren der Dienstprotokollkonfiguration',
    serviceLogRequirePin: 'Stift benötigen',
    serviceLogInfoPopup: 'Serviceprotokoll-Info-Popup anzeigen',
    serviceLogPlacementEdit : 'Platzierung anzeigen bearbeiten',
    commentViewOnMap: 'Auf Karte anzeigen',
    sldTagInUseErrorTitle: "Diese Aktion kann nicht durchgeführt werden. Das Tag wird gerade verwendet:",
    tab_AssetsMap: "Toiletten Karte",
    settings_checkbox_GoogleReviewAlerts: "Google review alerts"
}
